var map = {
	"./ball.svg": "wxHk",
	"./catch-up.svg": "J/Lb",
	"./dog.svg": "aIph",
	"./frisbee.svg": "/du0",
	"./mixed.svg": "CqVK",
	"./rope.svg": "90YD",
	"./run-short.svg": "aFUK",
	"./run-usual.svg": "LOrP",
	"./run-widely.svg": "aUbK",
	"./search-food.svg": "Jwmp",
	"./search-owner.svg": "RPWK",
	"./search-toy.svg": "K8eu",
	"./toy-food.svg": "fU+4",
	"./toy-heavy.svg": "3XBM",
	"./toy-soft-puppy.svg": "Gf+A",
	"./toy-soft-small.svg": "GRuk",
	"./toy-soft.svg": "CgEc",
	"./toy-squeaky.svg": "LmqH",
	"./training-aport.svg": "FDOn",
	"./training-basic.svg": "F7VE",
	"./training-discipline.svg": "vZtx",
	"./training-game.svg": "eqlh",
	"./training-jump-over.svg": "Pea8",
	"./training-jump.svg": "k89O",
	"./training-pick.svg": "nwc7",
	"./training-stranger.svg": "zJQu",
	"./training-trick.svg": "27sg",
	"./velo.svg": "GO37",
	"./walk-active.svg": "Thon",
	"./walk-quiet.svg": "1D8A"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "70PH";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/games ^\.\/.*\.svg$
// module id = 70PH
// module chunks = 1